import { getEnv } from "../../config/env";

export const BACKEND_ENDPOINT = getEnv("REACT_APP_BACKEND_ENDPOINT");

export const DEVELOPER_BACKEND_POINT = getEnv(
  "REACT_APP_DEVELOPER_BACKEND_POINT",
);

//users
export const CREATE_USER = "/vcs/services/accounts/users/createUsers";
export const GET_USER_DETAIL = "/vcs/services/accounts/users/getUserDetails";
export const UPDATE_USER = "/vcs/services/accounts/users/updateUsers";
export const DELETE_USER = "/vcs/services/accounts/users/deleteUsers";
export const GET_USER = "/vcs/services/accounts/users/getUsers";

// deactivate
export const DEACTIVATE_USER = "/vcs/services/accounts/users/deactivate";
export const REACTIVATE_USER = "/vcs/services/accounts/users/reactivate";
export const GET_USER_ACCOUNT_STATUS =
  "/vcs/services/accounts/users/getUserAccountStatus";
export const INITIATE_REACTIVATION =
  "/vcs/services/accounts/users/initiate-reactivation";
export const COMPLETE_REACTIVATION =
  "/vcs/services/accounts/users/complete-reactivation";
export const REQUEST_ACCOUNT_DELETION =
  "/vcs/services/accounts/users/requestAccountDeletion";
export const CANCEL_ACCOUNT_DELETION =
  "/vcs/services/accounts/users/cancelAccountDeletion";

//apps
export const GET_APP_DETAIL = "/vcs/services/accounts/apps/getAppDetails";
export const UPDATE_APP = "/vcs/services/accounts/apps/updateApps";
export const DELETE_APP = "/vcs/services/accounts/apps/deleteApps";
export const CREATE_APP = "/vcs/services/accounts/apps/createApps";
export const GET_APP = "/vcs/services/accounts/apps/getApps";

//devices
export const GET_DEVICE_DETAIL =
  "/vcs/services/accounts/devices/getDeviceDetails";
export const UPDATE_DEVICE = "/vcs/services/accounts/devices/updateDevice";
export const DELETE_DEVICE = "/vcs/services/accounts/devices/deleteDevice";
export const CREATE_DEVICE = "/vcs/services/accounts/devices/createDevice";
export const GET_DEVICES = "/vcs/services/accounts/devices/getDevices";
export const GET_DEVICE_FILE = "/vcs/services/accounts/devices/getDeviceFile";

//organisations
export const CREATE_ORGANISATION =
  "/vcs/services/accounts/organisations/createOrganisations ";
export const UPDATE_ORGANISATION =
  "/vcs/services/accounts/organisations/updateOrganisations";
export const GET_ORGANISATIONS =
  "/vcs/services/accounts/organisations/getOrganisations";
export const DELETE_ORGANISATION =
  "/vcs/services/accounts/organisations/deleteOrganisations ";
export const GET_ORGANISATION =
  "/vcs/services/accounts/organisations/getOrganisationDetails";
export const GET_ALL_ORGANISATIONS =
  "/vcs/services/accounts/organisations/getAllOrganisations";

//payments
// export const GET_PAYMENT_DETAILS = "/vcs/services/accounts/payments/getPaymentDetails"
// export const DELETE_PAYMENT = "/vcs/services/accounts/payments/deletePayments"
// export const CREATE_PAYMENT = "/vcs/services/accounts/payments/createPayments"
// export const GET_PAYMENTS = "/vcs/services/accounts/payments/getPayments"
// export const UPDATE_PAYMENT = "/vcs/services/accounts/payments/updatePayments"

export const CREATE_ORDER = "/vcs/services/accounts/payments/createOrders";
export const VERIFY_PAYMENT = "/vcs/services/accounts/payments/verifyOrders";
export const LIST_BILLING_DATA =
  "/vcs/services/accounts/payments/listBillingData";
export const GET_BILLING_DATA =
  "/vcs/services/accounts/payments/getBillingData";
export const CREATE_BILLING_DATA =
  "/vcs/services/accounts/payments/createBillingData";
export const UPDATE_BILLING_DATA =
  "/vcs/services/accounts/payments/updateBillingData";
export const DELETE_BILLING_DATA =
  "/vcs/services/accounts/payments/deleteBillingData";

//Notifications
export const CREATE_NOTIFICATION =
  "/vcs/services/notifications/createNotifications";
export const GET_NOTIFICATIONS = "/vcs/services/notifications/getNotifications";
export const DELETE_NOTIFICATION =
  "/vcs/services/notifications/deleteNotifications";
export const UPDATE_NOTIFICATION =
  "/vcs/services/notifications/updateNotifications";
